import { InterestedDealers } from "./../../../services/oem-dealer.service";
import { Component, OnInit, Input } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: "app-dealer-interessed-info-box",
  templateUrl: "./dealer-interressed-info-box.component.html",
  styleUrls: ["./dealer-interressed-info-box.component.scss"],
})
export class DealerInterressedInfoBoxComponent implements OnInit {
  @Input() dealer: InterestedDealers;

  seeMore = false;

  constructor() { }

  ngOnInit(): void { }
}
